import React from "react";
import PropTypes from "prop-types";
import { Helmet as ReactHelmet } from "react-helmet-async";

const Helmet = ({ title, content, keyword }) => {
  return (
    <ReactHelmet>
      <title>{title}</title>
      <meta name="description" content={content} keyword={keyword} />
    </ReactHelmet>
  );
};

Helmet.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  keyword: PropTypes.string.isRequired,
};

export default Helmet;
